<template>
  <div
    class="grid grid-cols-[auto_1fr] items-stretch gap-2 flex-grow backdrop-blur-lg rounded-lg overflow-hidden text-xs text-white"
  >
    <div class="flex flex-col self-start gap-1 justify-between items-stretch">
      <button
        v-if="chatStore.replyGenerating === false"
        class="btn btn-xs sm:btn-sm btn-square btn-ghost bg-zinc-800/50 drop-shadow-md"
        @click="clickRefresh()"
      >
        <i class="iconify mingcute--refresh-1-line" />
      </button>
      <button
        class="btn btn-xs sm:btn-sm btn-square btn-ghost bg-zinc-800/50 drop-shadow-md"
        @click="clickTextMode"
      >
        <i class="iconify mingcute--keyboard-line"></i>
      </button>
    </div>
    <div
      v-if="chatStore.replyGenerating"
      class="flex overflow-hidden w-full items-stretch"
    >
      <button
        class="btn btn-ghost btn-sm w-full pointer-events-none text-xs h-auto"
      >
        <span class="loading loading-xs" />
        <span>{{ $t(`Chats.thinking`) }}</span>
      </button>
    </div>
    <div
      v-else-if="chatStore.replyOptions.length > 0"
      class="flex flex-col items-center flex-1 overflow-hidden gap-1 chat-end max-h-[20rem]"
    >
      <div
        v-for="(reply, idx) in chatStore.replyOptions"
        :key="idx"
        class="btn btn-ghost flex h-fit w-full flex-1 overflow-auto bg-zinc-800/70 font-normal p-2 text-left hover:bg-zinc-900"
        @click="() => emit('replyText', reply)"
      >
        <div
          class="chat-container dark bg-transparent prose-xs"
          v-html="formatReply(reply)"
        />
      </div>
    </div>
    <div v-else class="flex overflow-hidden items-stretch">
      <button
        class="btn btn-ghost btn-sm w-full bg-zinc-800/50 overflow-hidden flex-wrap h-full"
        @click="clickRefresh()"
      >
        {{ $t("Chats.generateError") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import escapeHtml from "@/modules/escape-html";
import { marked } from "marked";
import { useChat } from "@/stores/chat";
import { InputTypeEnum } from "@/enums/chatEnums";

const props = defineProps<{
  mode: string;
  mateSessionId: number;
  type?: InputTypeEnum;
  temperature?: number;
}>();

const emit = defineEmits(["update:mode", "replyText"]);

const chatStore = useChat();

const clickTextMode = () => {
  emit("update:mode", "text");
};

const formatReply = (reply: string) => {
  return marked.parse(escapeHtml(reply));
};
const clickRefresh = async (msgId?: number) => {
  await chatStore.generateReply({
    mateSessionId: props.mateSessionId,
    messageId: msgId,
    type: props.type,
    temperature: props.temperature,
  });
};
const generateReplyOptional = (): Promise<string | void> => {
  return chatStore.generateReplyOptional({
    mateSessionId: props.mateSessionId,
    type: props.type,
    temperature: props.temperature,
  });
};

export interface OptionReplyInstance {
  generateReplyOptional: typeof generateReplyOptional;
}

defineExpose<OptionReplyInstance>({
  generateReplyOptional: generateReplyOptional,
});
</script>
